export default __webpack_public_path__ + "static/media/Archdeacon's Gloves of the Abyss.a9fe1bc2.jpg";